import useUserActions from 'Hooks/useUserActions';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import userState from 'Recoil/Atoms/User';

export default function UserEffect() {
  const user = useRecoilValue(userState);

  const { fetchUser } = useUserActions();

  useEffect(() => {
    if (user.logged) {
      fetchUser();
    }
  }, []);

  return null;
}
